const prefix = 'dpds';
const storage = {
  getRefreshToken() {
    return JSON.parse(window.localStorage.getItem(`${prefix}_refresh_token`) || 'null');
  },
  setRefreshToken(token: any) {
    window.localStorage.setItem(`${prefix}_refresh_token`, JSON.stringify(token));
  },
  getToken() {
    return JSON.parse(window.localStorage.getItem(`${prefix}_token`) || 'null');
  },
  setToken(token: any) {
    window.localStorage.setItem(`${prefix}_token`, JSON.stringify(token));
  },
  clearToken() {
    window.localStorage.removeItem(`${prefix}_token`);
  },
  get(key: string) {
    return JSON.parse(window.localStorage.getItem(`${prefix}_${key}`) || 'null');
  },
  set(data: Record<string, unknown> | string | number | any[], key: string) {
    window.localStorage.setItem(`${prefix}_${key}`, JSON.stringify(data));
  },
  clear(key: string) {
    window.localStorage.removeItem(`${prefix}_${key}`);
  },
  clearAll(prefix = 'dpds') {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
    });
  },
  getDpsdType() {
    return JSON.parse(window.localStorage.getItem(`${prefix}_type`) || 'null');
  },
  setDpdsType(token: any) {
    window.localStorage.setItem(`${prefix}_type`, JSON.stringify(token));
  },
  getId() {
    return JSON.parse(window.localStorage.getItem(`${prefix}_id`) || 'null');
  },
  setId(token: any) {
    window.localStorage.setItem(`${prefix}_id`, JSON.stringify(token));
  },
  getDealer() {
    return JSON.parse(window.localStorage.getItem(`${prefix}_dealer`) || 'null');
  },
  setDealer(token: any) {
    window.localStorage.setItem(`${prefix}_dealer`, JSON.stringify(token));
  },
  getVkorg() {
    return JSON.parse(window.localStorage.getItem(`${prefix}_vkorg`) || 'null');
  },
  setVkorg(token: any) {
    window.localStorage.setItem(`${prefix}_vkorg`, JSON.stringify(token));
  }
};

export default storage;
